export default __webpack_public_path__ + "media/grid/thumb-up_4x-a02a531a.png";